import { memo } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import ImportDialog from '../shared/ImportDialog.jsx';

/**
 * "Undo <batch>?": the members the import added are deleted (only possible while nobody of it was
 * invited). Mount it only while open.
 *
 * @param {object} props
 * @param {string} props.label Batch name, e.g. `Imported Oct 21 · roster.xlsx`.
 * @param {number} props.count People the import added.
 * @param {boolean} props.isBusy
 * @param {() => void} props.onConfirm
 * @param {() => void} props.onClose
 */
function UndoImportConfirm({ label, count, isBusy, onConfirm, onClose }) {
  const { t } = useTranslation('people-access');
  return (
    <ImportDialog
      onClose={onClose}
      isBusy={isBusy}
      titleId="undo-import-title"
      title={t('members.importBatch.confirm.title', { label })}
      footer={
        <>
          <Button variant="secondary" customButtonHeight="!h-[40px]" className="!px-6" data-autofocus disabled={isBusy} onClick={onClose}>
            {t('import.cancel')}
          </Button>
          <Button variant="danger" customButtonHeight="!h-[40px]" className="!px-6" disabled={isBusy} onClick={onConfirm}>
            {t('members.importBatch.confirm.confirm')}
          </Button>
        </>
      }
    >
      <p className="text-sm text-content-secondary">{t('members.importBatch.confirm.message', { count })}</p>
    </ImportDialog>
  );
}

export default memo(UndoImportConfirm);
